import { MapPin, StarOff } from "lucide-react";
import { ScrollArea, ScrollBar } from "../ui/scroll-area";

export function SavedLocationsStrip({ savedLocations, setLocation, setAiSummary, removeLocation }) {
  if (!savedLocations.length) return null;

  return (
    <ScrollArea className="w-full mb-6" data-testid="saved-locations-strip">
      <div className="flex gap-2 pb-2">
        {savedLocations.map((loc) => (
          <div
            key={loc.id}
            className="glass-light rounded-full px-4 py-2 whitespace-nowrap hover:bg-white/10 flex items-center gap-2 cursor-pointer"
            onClick={() => {
              setLocation({ lat: loc.lat, lon: loc.lon, name: loc.name });
              setAiSummary("");
            }}
            data-testid={`saved-location-${loc.id}`}
          >
            <MapPin className="w-3 h-3" />
            {loc.name}
            <button
              onClick={(e) => {
                e.stopPropagation();
                removeLocation(loc.id);
              }}
              className="ml-1 hover:text-red-400"
              data-testid={`remove-saved-location-${loc.id}`}
            >
              <StarOff className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
}